
export function requestJSONBy(url_path, onSuccessful=()=>{}, onFail=()=>{}) {
    fetch(new URL(url_path, process.env.REACT_APP_API_SERVER_URL).href).then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        return response.json();
    }).then((data) => {
        onSuccessful(data);
    }).catch((error) => {
        console.error("Fetch error:", error);
        onFail(error);
    });
}